import { Platform } from 'react-native';
import kylogger from '../log/kylogger';
import randomChars from '../randomChars';
function collect(...rest) {
    kylogger
        .getLogger()
        .then((logger) => {
        logger?.sendImmediately?.(...rest);
    })
        .catch((err) => {
        console.warn('reprot log error: ' + err.message);
    });
}
async function reportKdsError(info) {
    if (Platform.OS === 'web') {
        const logger = await kylogger.getLogger();
        const { failCount, errorCount, cost } = info;
        logger?.plugins.radar.event({
            name: info.business,
            event_type: info.subBusiness,
            category: info.group,
            message: info.message,
            extra_info: handleError(info.extra || {}),
        }, {
            event_count: failCount || errorCount,
            duration: cost,
        });
    }
    else {
        // 平台对err的stringify有问题，需要手动处理
        const data = { ...info, extra: handleError(info.extra || {}) };
        if (__DEV__) {
            // kds自定义错误不上报，防止淹没其他有效js报错
            console.warn(data);
        }
        else {
            console.info(data);
        }
    }
}
export function getErrMsg(info) {
    if (!info) {
        return '';
    }
    const errMsg = info?.message ||
        // @ts-ignore
        info?.errMsg ||
        // @ts-ignore
        info?.error_msg ||
        // @ts-ignore
        info?.errorMsg ||
        // @ts-ignore
        info?.msg;
    if (errMsg) {
        return errMsg;
    }
    if (typeof info === 'string') {
        return info;
    }
    return handleError(info);
}
/**
 * 处理错误信息
 * @param err
 * @exports
 */
function handleError(err) {
    let res = err;
    // 平台对err的stringify有问题，需要手动处理
    if (err?.message && err?.stack) {
        res = {
            message: err.message,
            stack: err.stack,
            // @ts-ignore
            componentStack: err.componentStack,
        };
    }
    try {
        return JSON.stringify(res);
    }
    catch (e) {
        return '';
    }
}
/**
 * 用于上报操作的类
 * @exports
 */
export class OperateReport {
    business;
    subBusiness;
    failCountMap = {};
    constructor(business, subBusiness = '') {
        this.business = business;
        this.subBusiness = subBusiness;
    }
    getEventKey(info) {
        const { group, componentName, bundleId, message } = info;
        return `${bundleId}_${componentName}_${group}_${message}`;
    }
    getErrorCount(info) {
        const key = this.getEventKey(info);
        if (this.failCountMap[key] === undefined) {
            this.failCountMap[key] = 1;
        }
        else {
            this.failCountMap[key]++;
            if (this.failCountMap[key] > 4) {
                delete this.failCountMap[key];
            }
        }
        return this.failCountMap[key];
    }
    start(info, allowOverwriteTime = 0) {
        let hasResult = false, t = 0;
        const startTime = Date.now();
        let progress = 0;
        const sessionId = randomChars(2) + '_' + startTime + '_' + randomChars(8);
        const commonInfo = {
            bundleId: kylogger.bundleId,
            componentName: kylogger.componentName,
            bundleVersion: kylogger.bundleVersion,
            business: this.business,
            subBusiness: this.subBusiness,
            isNew: 'new2',
            ...info,
            session_id: sessionId,
        };
        collect('CLICK', 'FE_OPERATE_START', {
            ...commonInfo,
            progress,
            cost: 0,
        });
        const uploadResult = (cb) => {
            if (hasResult) {
                console.warn('重复设置结果');
                return;
            }
            if (allowOverwriteTime) {
                t && window.clearTimeout(t);
                t = window.setTimeout(() => {
                    cb();
                    hasResult = true;
                }, allowOverwriteTime);
            }
            else {
                cb();
                hasResult = true;
            }
        };
        return {
            progress: (message) => {
                collect('CLICK', 'FE_OPERATE_PROGRESS', {
                    ...commonInfo,
                    message,
                    progress: ++progress,
                    cost: Date.now() - startTime,
                });
            },
            fail: (error, ignoreWarn = false, params) => {
                const cost = Date.now() - startTime;
                uploadResult(() => {
                    const _params = {
                        ...commonInfo,
                        result: 'F',
                        progress: ++progress,
                        cost,
                        failCount: this.getErrorCount(info),
                        message: getErrMsg(error),
                        extra: handleError(error),
                        params: params && JSON.stringify(params),
                    };
                    collect('CLICK', 'FE_OPERATE_RESULT', _params);
                    !ignoreWarn && reportKdsError(_params);
                });
            },
            success: () => {
                const cost = Date.now() - startTime;
                uploadResult(() => {
                    const key = this.getEventKey(info);
                    const params = {
                        ...commonInfo,
                        result: 'S',
                        progress: ++progress,
                        cost,
                    };
                    collect('CLICK', 'FE_OPERATE_RESULT', params);
                    delete this.failCountMap[key];
                });
            },
        };
    }
    reportError(error, eventInfo = {}, ignoreWarn = false) {
        const params = {
            business: this.business,
            subBusiness: this.subBusiness,
            message: getErrMsg(error),
            bundleVersion: kylogger.bundleVersion,
            bundleId: kylogger.bundleId,
            componentName: kylogger.componentName,
            ...eventInfo,
            extra: handleError(error),
        };
        params.errorCount = this.getErrorCount(params);
        collect('CLICK', 'FE_OPERATE_ERROR', params);
        !ignoreWarn && reportKdsError(params);
    }
}
export const operateReport = new OperateReport('custom_err');
/**
 * 上报错误
 * @param info
 * @exports
 */
export default (info) => operateReport.reportError(info?.extra || {}, info);
